import {css, html, LitElement} from 'lit';
import {repeat} from 'lit/directives/repeat.js';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-checklist')
export class Checklist extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      :host {
        background: var(--color-light-grey);
        border-radius: .6rem;
        display: block;
        max-width: 392px;
        padding: 1.2rem 1.6rem;
      }

      h5 {
        font-family: var(--font-family-alternative);
        font-size: .8rem;
        font-weight: var(--font-weight-strong);
        margin: 0 0 1rem;
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0;
      }

      li {
        align-items: baseline;
        display: flex;
        font-family: var(--font-family-alternative);
        font-size: .7rem;
        font-weight: var(--font-weight-base);
        line-height: 1.3;
        margin-bottom: .9rem;
      }

      li:last-child {
        margin-bottom: 0;
      }

      li svg {
        flex: 0 0 12px;
        height: 8px;
        margin-right: .8rem;
        width: 12px;
      }
    `
  ];

  @property()
  title: string;

  @property({type: Array})
  items: string[];

  protected render(): unknown {
    return html`
      ${this.title ? html`<h5>${this.title}</h5>` : ''}

      ${this.items ? html`
        <ul>
          ${repeat(this.items, (item, index) => html`
            <li>
              <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5L5 9L13 1" stroke="#FF8A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              ${item}
            </li>
          `)}
        </ul>
      ` : ''}
    `;
  }
}
